var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-403"},[_c('ErrorPage',[_c('img',{attrs:{"slot":"img","src":require("../assets/image/500.svg"),"alt":""},slot:"img"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }